import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { applyStoredTheme } from './theme';

applyStoredTheme();   // set the saved light/dark choice before first paint

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
